/**
 * Common worksheet settings keys.
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/service/WorkbookSettingsConstants.java
 */
export const WORKSHEET_SETTINGS_CONSTANTS = {
  WORKSHEET_BACKGROUND_COLOR: 'common.worksheet.background.color',
  WORKSHEET_POPUP_MARKER: 'common.worksheet.popup.marker',
  WORKSHEET_VIEW_BORDERS: 'common.worksheet.view.borders'
};
